import React from "react";
import { Box, Typography, IconButton, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./DeleteServicePopup.scss";

type DeleteServicePopupProps = {
  open: boolean;
  message?: string;
  title?: string;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteServicePopup: React.FC<DeleteServicePopupProps> = ({
  open,
  message = "Are you sure you want to delete?",
  onClose,
  onConfirm,
  title,
}) => {
  return (
    <Modal
      open={open}
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
    >
      <Box className="delete-service-popup">
        <Box className="delete-service-popup__header">
          <Typography className="delete-service-popup__title">
            {title ?? "Delete Message"}
          </Typography>
          <IconButton
            className="delete-service-popup__close-btn"
            onClick={onClose}
          >
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>

        <Typography className="delete-service-popup__message">
          {message}
        </Typography>

        <Box className="delete-service-popup__actions">
          <Button
            className="delete-service-popup__btn delete-service-popup__btn--no"
            onClick={onClose}
            variant="outlined"
          >
            No
          </Button>
          <Button
            className="delete-service-popup__btn delete-service-popup__btn--yes"
            onClick={onConfirm}
            color="error"
          >
            Yes
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteServicePopup;
